import { DismissedByWorkflow } from "./DismissedByWorkflow"

import type { DismissedByLabelComponent } from "."

const KODEM = "Kodem"

export const DismissedByLabel: DismissedByLabelComponent = (props) => {
  const { dismissMethod, dismissedBy, t } = props

  if (dismissMethod === "manual") return dismissedBy

  if (dismissedBy === KODEM) return "Kodem"

  return <DismissedByWorkflow workflowId={dismissedBy} t={t} />
}
